define([
	"dojo/_base/declare",
	"csi/property/ImageLeftController"
], function(declare,ImageLeftController) {

	return declare(ImageLeftController, {
		// Number: direction to move key
		_nOffset: 1
	});
});